// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"3":"PurchaseMysteryPackModal","69":"CheckNft","234":"WrapForButtonBuy","895":"SocialNetworkLeftSide"}[chunkId] || chunkId) + "." + {"3":"ea596ec1","69":"b79dd7fa","234":"f27b5ba5","792":"dc6c9872","895":"eaa61706"}[chunkId] + ".chunk.js";
};